import SanctionRecord from '../alert/matches/SanctionRecord';
import React, { Fragment, ReactNode } from 'react';
import { ApiSanctionRecord } from '../../api';
import PoweredByDowJones from '../dow-jones/powered-by-dow-jones';
import {
  InternalApiScreeningListType,
  InternalApiScreeningManualSearchHit,
  InternalApiScreeningMatchProvider,
  InternalApiScreeningRecord,
} from '../../api-internal';
import { getHighlightedText } from '../../aml/sections/attributes/highlighters';

export const displayMatchDetails = (
  matchData: string,
  record?: ApiSanctionRecord | InternalApiScreeningRecord,
  highlight?: string
) => {
  const properties = JSON.parse(matchData);
  if (record) {
    return <SanctionRecord highlight={highlight} sanctionRecord={record} />;
  } else {
    return (
      <pre className='prewrap' data-testid='match-data'>
        {getHighlightedText({
          text: JSON.stringify(properties, null, 2),
          highlight,
        })}
      </pre>
    );
  }
};

export const sliceHitsByPage = (hits: InternalApiScreeningManualSearchHit[], size: number, page: number) => {
  const offset = page * size;
  return hits.slice(offset, offset + size);
};

export const getMatchesHeader = () => {
  return (
    <tr>
      <th className='sanction-match-field'>MATCH</th>
      <th>SCORE</th>
      <th>SOURCE</th>
    </tr>
  );
};

const getRecord = (
  hit: InternalApiScreeningManualSearchHit
): ApiSanctionRecord | InternalApiScreeningRecord | undefined => {
  return (hit as InternalApiScreeningManualSearchHit).screeningRecord;
};

export const displayHits = (
  hits: InternalApiScreeningManualSearchHit[],
  displayDetails: (
    matchData: string,
    record?: ApiSanctionRecord | InternalApiScreeningRecord,
    highlight?: string
  ) => ReactNode
) => {
  return hits.map((hit: InternalApiScreeningManualSearchHit, index) => {
    const details = displayDetails(hit.matchData, getRecord(hit), hit.highlight);
    return (
      <Fragment key={hit.id}>
        <tr className={`custom-table-row-${index % 2}`}>
          <td>{details}</td>
          <td style={{ verticalAlign: 'top' }}>{hit.score}</td>
          <td style={{ verticalAlign: 'top' }}>
            <span>{hit.sanctionList}</span>
            <br />
            <span>
              ID: <span>{hit.id}</span>
            </span>
            {hit.matchProvider === InternalApiScreeningMatchProvider.DOW_JONES && <PoweredByDowJones />}
          </td>
        </tr>
      </Fragment>
    );
  });
};

export const getAllowedScreeningTypes = (isAdverseMediaEntityEnabled: boolean): InternalApiScreeningListType[] => {
  if (isAdverseMediaEntityEnabled) {
    return [
      InternalApiScreeningListType.SANCTION,
      InternalApiScreeningListType.PEP,
      InternalApiScreeningListType.ADVERSE_MEDIA,
      InternalApiScreeningListType.ADVERSE_MEDIA_ENTITY,
    ];
  }
  return [
    InternalApiScreeningListType.SANCTION,
    InternalApiScreeningListType.PEP,
    InternalApiScreeningListType.ADVERSE_MEDIA,
  ];
};
